import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
export function MobileOfferBar() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const hero = document.getElementById("top");
    const offer = document.getElementById("offer");
    if (!hero || !offer || typeof IntersectionObserver === "undefined") return;
    let heroVisible = true;
    let offerVisible = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === hero) heroVisible = entry.isIntersecting;
        if (entry.target === offer) offerVisible = entry.isIntersecting;
      });
      setShow(!heroVisible && !offerVisible);
    });
    observer.observe(hero);
    observer.observe(offer);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-30" data-mp="3udn4zxa9l2iz">
      {show && <motion.div initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy-900 text-ice md:hidden" style={{
      paddingBottom: "env(safe-area-inset-bottom)"
    }} data-id="element-31" data-mp="3pek2oklo5aep">
          <div className="container-x flex h-[70px] items-center justify-between gap-4" data-id="element-32" data-mp="2ki98smd6ruj3">
            <div className="leading-tight" data-id="element-33" data-mp="2pcdivehr0ioe">
              <p className="font-display text-2xl font-extrabold" data-id="element-34" data-mp="2td5rc5isqjjm">USD $27</p>
              <p className="text-[12px] text-ice/70" data-id="element-35" data-mp="2ybqry61yn58l">Book + all 5 bonuses</p>
            </div>
            <a href="#offer" className="btn-small h-11" data-id="element-36" data-mp="2ydk0xs01q1jr">
              See the bundle
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}